import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {
  RegulatoryNewsMain,
  IframeContainer,
  ChangeTabLink
} from './index.style'
import Spacer from '@components/Spacer'
import { TextBody2 } from '@components/TextStyles'

const RegulatoryNews = () => {

  const firstIframeUrl = 'https://polaris.brighterir.com/public/brave_bison/news/rns';
  const changeTab = () => {
    const newUrl = `${window.location.origin}${window.location.pathname}?tab=regulatory-news-alert`
    window.history.pushState({}, null, newUrl);
    var event = new CustomEvent("changeTab", { "detail": "Example of an event" });
    window.dispatchEvent(event);
  }

  return (
    <RegulatoryNewsMain>
      <TextBody2>If you would like to subscribe to our regulatory news email and alerts, then please <ChangeTabLink onClick={changeTab}>click here.</ChangeTabLink></TextBody2>
      <Spacer size={[20, 40]} />
      <IframeContainer>
        <iframe width="100%" height="800px" frameBorder="0" src={firstIframeUrl}
          loading="lazy"></iframe>
      </IframeContainer>
      <Spacer size={[40, 80]} />
    </RegulatoryNewsMain>
  )
}

export default RegulatoryNews
